import { Employee } from "@/Common/Api/Employee/Dto/Employee";
import { SitesModel } from "@/Common/Models/Sites/SitesModel";
import { SiteUIModel } from "@/Common/Models/Sites/SiteUIModel";
import { EmployeeUIModel } from "@/Common/Models/UI/Employee/EmployeeUIModel";
import { CheckboxTarget } from "@/Common/Models/UI/Inputs/CheckboxTarget";

class CacheHelper {
    public static LoadSitesFromCache(checkTarget: number): SiteUIModel[] {
        return cacheStore.SiteCache.map((s: SitesModel) => {
            var site = SiteUIModel.FromCompositeObject(s);
            site.Checked = true;
            site.Target = checkTarget;
            return site;
        });
    }

    public static LoadActiveClinicianUICache(target: CheckboxTarget, onlyIsShared: boolean, checked: boolean = false): EmployeeUIModel[] {
        var clinicians = cacheStore.GetActiveEmployees();

        return clinicians.filter(e => !onlyIsShared || e.IsSharingLabs != false || e.ContactFacet_id == sessionStore.getCurrentEmployee().ContactFacetId)
            .map(e => {
                var employee = EmployeeUIModel.fromCompositeObject(e);
                employee.Target = target;
                employee.Id;
                employee.Checked = checked;
                return employee;
            });
    }

    public static LoadClinicianUICache(target: CheckboxTarget, onlyIsShared: boolean, checked: boolean = false): EmployeeUIModel[] {
        var result: EmployeeUIModel[] = [];
        var filtered = cacheStore.EmployeeCacheWithInactive.filter(
            (e: Employee) =>
                (
                    onlyIsShared
                    && !e.IsSharingLabs
                    && e.ContactFacet_id != cacheStore.GetCurrentEmployee().ContactFacet_id
                ) === false
        );

        result = filtered.map((e: Employee) => {
            var employee = EmployeeUIModel.fromCompositeObject(e);
            employee.Target = target;
            employee.Id;
            employee.Checked = checked;
            return employee;
        });

        return result;
    }

    public static LoadCLinicianUICacheIncludeDeactivated(target: CheckboxTarget): EmployeeUIModel[] {
        return cacheStore.EmployeeCache.map((e: Employee) => {
            var employee = EmployeeUIModel.fromCompositeObject(e);
            employee.Target = target;
            employee.Id;
            return employee;
        });
    }
}

export { CacheHelper };
